module.exports = __webpack_public_path__ + "img/chatfood-icon.27cb66f4.png";